

export const baseURL = 'https://api.pelakeman.com/api'
// export const baseURL = 'https://veeu.sekans.art/api'

export const baseURLWithoutAPI = 'https://api.pelakeman.com'
export const baseURLImgs = 'https://api.pelakeman.com'



// export const getImgsBaseUrl = "https://veeu.sekans.art/"

/*
export const baseURL = 'https://localhost:7292/api'
export const baseURLWithoutAPI = 'https://localhost:7292.com'
export const baseURLImgs = 'https://alocalhost:7292.com'
*/